<p-toast />
<p-confirmDialog />
<div class="app-shell">
  <kmt-topbar />
  <div class="app-content">
    <router-outlet></router-outlet>
  </div>
  <footer class="app-footer">
    <p>Version {{ version }}</p>
    <p>© 2025 Kuhnert Messtechnik</p>
  </footer>
</div>
